// extracted by mini-css-extract-plugin
export default {"mySlct":"MySelect_mySlct__W-UpY"};